import React, { useState, useEffect, useContext } from "react";

import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import TablePagination from "@mui/material/TablePagination";

import ListLogTable from "./TableLogEstruturado/index";
import BorderedDatePicker from "./DatePicker";
import Button from "../../../../../components/Button-v2";
import BorderForSelectNumberOfRecords from "../../../../../components/BorderForSelectNumberOfRecords";
import FrontCreditoIcon from "../../../../../assets/navbar/Front_Credito_on_light_blue.svg";
import { retrieveLogEstruturado } from "../../../../../services/frontCredito/index";
import { Context } from "../../../../../context/globalContext";

import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";

import {
  CardWrapper,
  Label,
  Card,
  CardHeader,
  Header,
  BoxUser,
  Image,
  Description,
  Title,
  RodaPe,
  SelectPaginacaoWrapper,
  SelectContainer,
  PopupBackground,
  PopupContainer,
  TitleCloseBtn,
  CheckboxWrapper,
} from "../../styles";
import Input from "../../Input";
import Checkbox from "../../../../../components/Checkbox";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

const today = new Date();
const dayInMilli = 86400000;
const thirtyDaysAgo = new Date(today - 30 * dayInMilli);

const LogEstruturadoComponent = (props) => {
  const classes = useStyles();

  const { pageLimit } = useContext(Context);

  const [logs, setLogs] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [dataInicio, setDataInicio] = useState(thirtyDaysAgo);
  const [dataFim, setDataFim] = useState(today);
  const [pesquisa, setPesquisa] = useState("");
  const [showEmptyPreviousValue, setShowEmptyPreviousValue] = useState(true);
  const [filters, setFilters] = useState({
    cpfCnpj: props.cpfCnpj,
    dataInicio,
    dataFim,
    pesquisa,
    showEmptyPreviousValue,
    pageable: {
      page: 0,
      size: pageLimit,
      sortColumn: null,
      sortDirection: "ASC",
    },
  });

  useEffect(() => {
    getDataByFilters(filters);
  }, [filters]);

  const handleChangePageSize = (item) => {
    setFilters({
      ...filters,
      pageable: {
        ...filters.pageable,
        size: item.id,
      },
    });
  };

  const handleChangePage = (p, newPage) => {
    setFilters({
      ...filters,
      pageable: {
        ...filters.pageable,
        page: newPage,
      },
    });
  };

  const clear = () => {
    setDataInicio(thirtyDaysAgo);
    setDataFim(today);
  };

  const applyFilters = () => {
    setFilters({
      ...filters,
      dataInicio,
      dataFim,
      pesquisa,
      showEmptyPreviousValue,
      pageable: {
        ...filters.pageable,
        page: 0,
      },
    });
  };

  async function getDataByFilters(filters) {
    setIsLoading(true);
    setLogs([]);
    setTotalElements(0);

    retrieveLogEstruturado(filters)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          const {
            data: { content, total },
          } = response;

          setLogs(content);
          setTotalElements(total);
        } else if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .finally(() => setIsLoading(false));
  }

  const onClose = () => {
    props.setOpenPopup(false);
  };

  return (
    <PopupBackground>
      <PopupContainer>
        <TitleCloseBtn>
          <button onClick={onClose}>
            <IoClose />
          </button>
        </TitleCloseBtn>
        <Header>
          <BoxUser>
            <Image src={FrontCreditoIcon} />
            <div>
              <Title>Front de Crédito</Title>
              <Description>Cadastro</Description>
            </div>
          </BoxUser>
        </Header>
        <CardWrapper>
          <Label>Histórico de cadastro</Label>
          <Card>
            <Grid container spacing={3}>
              <Grid item xs={12} md={2}>
                <BorderedDatePicker
                  label="Data inicial"
                  selected={dataInicio}
                  setSelected={setDataInicio}
                  disabled={isLoading}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <BorderedDatePicker
                  label="Data final"
                  selected={dataFim}
                  setSelected={setDataFim}
                  disabled={isLoading}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label="Nome do campo"
                  onChange={setPesquisa}
                  value={pesquisa}
                  disabled={isLoading}
                  border="1px solid #cbcccc"
                  color="white"
                />
              </Grid>
              <Grid item xs={12} md={3} alignSelf="flex-end">
                <CheckboxWrapper>
                  <Checkbox
                    marked={showEmptyPreviousValue}
                    onClick={() =>
                      setShowEmptyPreviousValue(!showEmptyPreviousValue)
                    }
                  />
                  <span>
                    Exibir campos com valor <br />
                    anterior em branco
                  </span>
                </CheckboxWrapper>
                <div style={{ height: "0.4rem" }}></div>{" "}
                {/* apenas para corrigir o alinhamento por causa das margens dos datepickers (remover quando refazer os datepickers)*/}
              </Grid>
              <Grid item xs={12} md={1} alignSelf="flex-end">
                <Button
                  fontSize="12px"
                  width="100%"
                  height="32px"
                  disabled={isLoading}
                  type="button"
                  onClick={clear}
                >
                  Limpar
                </Button>
                <div style={{ height: "0.4rem" }}></div>{" "}
                {/* apenas para corrigir o alinhamento por causa das margens dos datepickers (remover quando refazer os datepickers)*/}
              </Grid>
              <Grid item xs={12} md={1} alignSelf="flex-end">
                <Button
                  fontSize="12px"
                  width="100%"
                  height="32px"
                  disabled={isLoading}
                  loading={isLoading}
                  type="button"
                  onClick={applyFilters}
                >
                  Filtrar
                </Button>
                <div style={{ height: "0.4rem" }}></div>{" "}
                {/* apenas para corrigir o alinhamento por causa das margens dos datepickers (remover quando refazer os datepickers)*/}
              </Grid>
            </Grid>
            <CardHeader>
              <span>
                {`${totalElements} cadastro${
                  totalElements === 1 ? "" : "s"
                } encontrado${totalElements === 1 ? "" : "s"}`}
              </span>
            </CardHeader>
            <Grid item md={12}>
              <ListLogTable logs={logs} isLoading={isLoading} />
            </Grid>
            <Grid item md={12}>
              <RodaPe>
                <SelectPaginacaoWrapper>
                  <SelectContainer>
                    <BorderForSelectNumberOfRecords
                      selected={0}
                      handleSearch={handleChangePageSize}
                      initialValue={pageLimit}
                    />
                  </SelectContainer>
                </SelectPaginacaoWrapper>
                <TablePagination
                  component="div"
                  classes={{
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                  }}
                  count={totalElements}
                  page={filters.pageable.page || 0}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from} - ${to} de ${count}`
                  }
                  onPageChange={handleChangePage}
                  rowsPerPageOptions={[]}
                  rowsPerPage={filters.pageable.size}
                />
              </RodaPe>
            </Grid>
          </Card>
        </CardWrapper>
      </PopupContainer>
    </PopupBackground>
  );
};

export default LogEstruturadoComponent;
